module.exports = __webpack_public_path__ + "static/media/auto-wojdyla.82659904.png";